//Almacena la info de la DB
// const urlServer = 'https://us-central1-saluta-app.cloudfunctions.net/app/api';
// const urlWeb = 'https://saluta-app.web.app';

// const urlServer = 'http://localhost:5000/medivalecu/us-central1/app/api';
// const urlWeb = 'http://localhost:3000';

const urlServer = 'https://us-central1-medivalecu.cloudfunctions.net/app/api';
const urlWeb = 'https://medivalecu.web.app';

export { urlServer, urlWeb };

